import { getLineHeight as getGlobalLineHeight } from './global';
export function getLineHeight(transformer) {
    const globalLineHeight = getGlobalLineHeight(transformer);
    return Object.freeze({
        heading: globalLineHeight.narrow,
        currency: {
            integers: {
                s: globalLineHeight.normal,
                m: globalLineHeight.minimal,
                l: globalLineHeight.minimal,
            },
            decimals: {
                m: globalLineHeight.minimal,
                l: globalLineHeight.minimal,
            },
        },
        form: {
            amountInput: globalLineHeight.narrow,
            input: globalLineHeight.minimal,
            textarea: globalLineHeight.normal,
        },
        body: globalLineHeight.normal,
    });
}
